export type DateSelectionValue = Date | null | 'INVALID';
